/**
 * The booth's language, resolved without React, i18n state or the preload
 * bridge being healthy.
 *
 * Both crash guards that render *outside* the app tree need this:
 * `DuplicateLaunchGate` (runs before the booth boots) and
 * `RootErrorBoundary` (runs after the tree has already thrown, so nothing
 * inside it can be trusted). They can't use `useTranslation()`, so they take
 * a fixed `t` for this language instead.
 */

/** The languages the booth ships operator-facing copy in. */
export const GUARD_LANGUAGES = ['en', 'id', 'es']

/** The booth's saved language, else the OS's, as the shell's own dialog does. */
export function guardLanguage(): string {
  try {
    const saved = localStorage.getItem('language')
    if (saved && GUARD_LANGUAGES.includes(saved)) return saved
  } catch {
    // Unreadable storage (a dead-profile window): fall through to the OS language.
  }
  // `navigator?.language` and not `navigator.language`: this also runs under
  // node in tests, where the global exists but carries no language.
  const os = String((typeof navigator !== 'undefined' && navigator?.language) || '')
    .slice(0, 2)
    .toLowerCase()
  return GUARD_LANGUAGES.includes(os) ? os : 'en'
}
